<div class="deleteTopHeader">
    <div></div>
    <div class="delete_close_icon" mat-dialog-close><img src="/icons/close-light-grey.svg" width="20px" alt="Close">
    </div>
</div>
<mat-dialog-content>
    <p class="fs-20">{{_data?.line1}}</p>
    <p class="fs-20">{{_data?.line2}}</p>
    <p class="fs-20">{{_data?.line3}}</p>
    <p class="fs-20">{{_data?.line4}}</p>
    <div class="ownpartnumber-btnblock">
        <button mat-dialog-close (click)="closeAcc(true)"
            class="btn btn-block btn-primary action-button">{{'common.text_quote_yes_button_label'|cxTranslate}}
            <img src="/icons/link-grey.svg" style="width: 20px;" alt="">
        </button>
        <button class="btn btn-block btn-launch btn-primary" mat-dialog-close
            (click)="closeAcc(false)">{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}
        </button>
    </div>
</mat-dialog-content>